interface TeamNameOptions {
    teamName?: string | null;
    firstName?: string | null;
    lastName?: string | null;
}

export const getTeamDisplayName = (options: TeamNameOptions): string => {
    const {teamName, firstName, lastName} = options;

    if (teamName && teamName.trim() !== '') {
        return teamName;
    }

    // Fall back to user name if no team name is available
    const trimmedFirstName = firstName?.trim();
    const trimmedLastName = lastName?.trim();

    if (trimmedFirstName && trimmedLastName) {
        return `${trimmedFirstName} ${trimmedLastName}`;
    }

    if (trimmedFirstName) {
        return trimmedFirstName;
    }

    // Return null if no team is assigned and '' if a team exists but team name and user name are both empty
    return teamName && teamName.trim() === '' ? '' : null;
};
